import { CSSProperties } from 'react';

import { divider } from './styles.css';

export interface DividerProps {
  /**
   * @default : "horizontal"
   */
  direction?: 'horizontal' | 'vertical';
  /**
   * @default "small"
   */
  size?: 'small' | 'large';
  style?: CSSProperties;
}

export const Divider = (props: DividerProps) => {
  const { direction, size, style } = props;
  return <div className={divider({ direction, size })} style={style} />;
};
